const storageKey = (key: string) => `@milvio:${key}`;
export default storageKey;
